import { matchPath } from 'react-router';
import type { match } from 'react-router';

const getPageFromPrefix = (prefix: string, pageMatch: match<Record<string, string>>, redirectToPrefix = false) => {
  const { mode, currentPage } = pageMatch.params;

  if (mode === 'artist') {
    switch (currentPage) {
      case 'intent':
      case 'signup':
        return `${prefix}/artist/create`;
      case 'create':
        return `${prefix}/artist/genres`;
      case 'genres':
        return `${prefix}/artist/photo`;
      case 'photo':
        return `${prefix}/artist/info`;
      case 'info':
        return `${prefix}/artist/accounts`;
      case 'accounts':
        return `${prefix}/artist/identification`;
      case 'identification':
        return `${prefix}/artist/complete`;
      case 'complete':
        return redirectToPrefix ? prefix : '/connect';
      default:
        return `${prefix}/artist/create`;
    }
  }

  switch (currentPage) {
    case 'intent':
    case 'signup':
      return `${prefix}/host/create`;
    case 'create':
      return `${prefix}/host/space`;
    case 'space':
      return `${prefix}/host/photo`;
    case 'photo':
      return `${prefix}/host/info`;
    case 'info':
      return `${prefix}/host/identification`;
    case 'identification':
      return `${prefix}/host/complete`;
    case 'complete':
      return redirectToPrefix ? prefix : '/connect';
    default:
      return `${prefix}/host/create`;
  }
};

export const getFirstPageUrl = () => {
  const signupFirstStagePath = '/signup/:mode';
  const signupPath = '/signup/:mode/:currentPage';
  const connectPath = '/connect/:showCallId/:mode/:currentPage';

  let currentMatch: match<Record<string, string>> = matchPath(window.location.pathname, { path: signupFirstStagePath, exact: true });

  if (currentMatch) {
    return '/signup/intent';
  }

  currentMatch = matchPath(window.location.pathname, { path: signupPath, exact: true });

  if (currentMatch) {
    return '/signup/intent';
  }

  currentMatch = matchPath(window.location.pathname, { path: connectPath, exact: true });

  if (currentMatch) {
    const { showCallId } = currentMatch.params;

    return `/connect/${showCallId}`;
  }

  return '/connect';
};

export const getNextPageUrl = () => {
  const signupFirstStagePath = '/signup/:mode';
  const signupPath = '/signup/:mode/:currentPage';
  const connectPath = '/connect/:showCallId/:mode/:currentPage';

  let currentMatch: match<Record<string, string>> = matchPath(window.location.pathname, { path: signupFirstStagePath, exact: true });

  if (currentMatch) {
    return getPageFromPrefix('/signup', currentMatch);
  }

  currentMatch = matchPath(window.location.pathname, { path: signupPath, exact: true });

  if (currentMatch) {
    return getPageFromPrefix('/signup', currentMatch);
  }

  currentMatch = matchPath(window.location.pathname, { path: connectPath, exact: true });

  if (currentMatch) {
    const { showCallId } = currentMatch.params;

    return getPageFromPrefix(`/connect/${showCallId}`, currentMatch, true);
  }

  return '/connect';
};
